










































import Vue from 'vue';
import { IHeaderComponent } from '@/common/interfaces/header.interface';
import TIcons from '@/types/TIcons';
import EventListenerHelper from '@/helpers/EventListenerHelper';
import PartnerChangeCustomerMailAddressOverlay from '@/components/layout/PartnerChangeCustomerMailAddressOverlay.vue';
import CustomerHelper from '../../helpers/CustomerHelper';
import config from '../../../config';
import CurrencyHelper from '../../helpers/CurrencyHelper';
import CookieHelper from '../../helpers/OldCookieHelper';
import HeaderDesktop from './subcomponents/HeaderDesktop.vue';
import HeaderMobile from './subcomponents/HeaderMobile.vue';
import LanguageHelper from '../../helpers/LanguageHelper';
import LocalStorageHelper from '../../helpers/LocalStorageHelper';
import ErrorHandlerHelper from '../../helpers/ErrorHandlerHelper';
import PartnerShopMethods from '../../methods/PartnerShopMethods';
import PartnerShopHelper from '../../helpers/page-specific/PartnerShopHelper';
import URLHelper from '../../helpers/URLHelper';
import OldCartHelper from '../../helpers/OldCartHelper';

export default Vue.extend({
  name: `Header`,
  components: { HeaderDesktop, HeaderMobile, PartnerChangeCustomerMailAddressOverlay },
  data(): IHeaderComponent {
    return {
      cartItemCount: LocalStorageHelper.getCartItemsCount(),
      currencies: [],
      customerMailMissing: {
        customerNumber: null,
        showOverlay: false,
      },
      icons: TIcons,
      isPartner: false,
      isPartnerShop: false,
      languages: [],
      loading: true,
      loggedIn: false,
      menuItems: {
        loggedInCustomer: [],
        loginAndCart: [],
        mainNav: [],
      },
      mobileView: true,
      partnerShopInformation: PartnerShopHelper.getInitialPartnerShopData(),
    };
  },
  computed: {
    chosenCurrency(): string {
      return CookieHelper.getCurrency();
    },
    chosenLanguage(): string {
      return CookieHelper.getLanguage() ? CookieHelper.getLanguage() : `DE`;
    },
  },
  created(): void {
    window.addEventListener(`resize`, this.reportWindowSize);
    document.addEventListener(`rin-cart-update`, this.handleCartCount);
    if(URLHelper.parsedUrlObject.hash === `#newsletter`) {
      EventListenerHelper.setUpEventListeners([{ callback: this.scrollIntoSubscribeSection, name: `newsletter-section-loaded` }]);
    }
    if(URLHelper.parsedUrlObject.slug === `salestool`) {
      EventListenerHelper.setUpEventListeners([{ callback: this.createCustomerCart, name: `salestool-create-customer-cart` }]);
    }
  },
  beforeDestroy(): void {
    window.removeEventListener(`resize`, this.reportWindowSize);
    EventListenerHelper.teardownEventListeners([
      { callback: this.scrollIntoSubscribeSection, name: `newsletter-section-loaded` },
      { callback: this.createCustomerCart, name: `salestool-create-customer-cart` },
    ]);
  },
  async mounted(): Promise<void> {
    window.$swal = this.$swal;
    const getLoginState = CustomerHelper.getLoggedInState();
    if(getLoginState) {
      this.loggedIn = true;
    }
    this.isPartner = CustomerHelper.getPartnerStatus();
    this.reportWindowSize();
    this.getLanguages();
    this.getCurrencies();
    await Promise.all([
      this.fetchMenuItems(),
      this.checkForPartnerShop(),
    ]);
  },
  methods: {
    ...PartnerShopMethods,
    closeOverlay(): void {
      this.customerMailMissing = { customerNumber: null, showOverlay: false };

      this.$swal({
        title: this.$t(`header:customerCartCreated`),
        type: `success`,
      });
    },
    async createCustomerCart(event: CustomEvent<{ customerNumber: number; matchcode: string }>) {
      this.$swal({
        title: this.$t(`header:waitForCartCreation`),
        type: `info`,
      });
      try {
        const { cartId, cartTypeId, info } = await OldCartHelper.createCustomerCart(event.detail.customerNumber) as { cartId: number; cartTypeId: number; info: string };
        this.customerMailMissing.showOverlay = info === config.api.errorCodes.partnerCustomerCartMailAddressMissing;

        if(event.detail.matchcode) {
          await OldCartHelper.addItemToCart(
            { matchcode: event.detail.matchcode },
            cartId,
            cartTypeId,
          );
        }
      } catch (err) {
        ErrorHandlerHelper.handleError(this.$t(err.message), { showSwal: true });
        return;
      }

      if(this.customerMailMissing.showOverlay) {
        // The typings of vue-sweetalert2 are broken and don't recognize the close() function.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$swal.close();
        this.customerMailMissing.customerNumber = event.detail.customerNumber;
      } else {
        await this.$swal({
          title: event.detail.matchcode ? this.$t(`header:customerCartCreatedAndProductAdded`) : this.$t(`header:customerCartCreated`),
          type: `success`,
        });
      }
    },
    async fetchMenuItems(): Promise<void> {
      if(this.isPartner) {
        this.menuItems = await this.$wpApiService.getWpMenuItemsForPartners({
          data: {
            lang: this.chosenLanguage,
          },
        });
      } else {
        this.menuItems = await this.$wpApiService.getWpMenuItems({
          data: {
            lang: this.chosenLanguage,
          },
        });
      }
      this.loading = false;
    },
    async getCurrencies(): Promise<void> {
      try {
        this.currencies = await CurrencyHelper.fetchCurrencies();
      } catch (err) {
        ErrorHandlerHelper.handleError(err, { logToConsole: true });
      }
    },
    async getLanguages(): Promise<void> {
      try {
        this.languages = await LanguageHelper.fetchLanguages();
      } catch (err) {
        ErrorHandlerHelper.handleError(err, { logToConsole: true });
      }
    },
    handleCartCount(): void {
      this.cartItemCount = LocalStorageHelper.getCartItemsCount();
    },
    reportWindowSize(): void {
      this.mobileView = window.innerWidth < config.breakpoints.smallDesktop;
    },
    scrollIntoSubscribeSection(): void {
      const newsletterSection = document.getElementById(`newsletter`);
      return newsletterSection?.scrollIntoView();
    },
    switchCurrency(currency: string): void {
      CookieHelper.setCurrency(currency);
      LocalStorageHelper.setCurrency(currency); // for ringana.js legacy sCur
      window.location.reload();
    },
    switchLanguage(language: string): void {
      CookieHelper.setLanguage(language);
      // allow switching to new language directly on select sites
      // /corporate/ is shared namespace through all languages
      if(window.location.pathname.match(`^/corporate/`)) {
        const query = (language !== `de`) ? `?lang=${language}` : ``;
        window.location.href = `${window.location.pathname}${query}`;
      } else {
        // reload site to fall back to the handling with cookie and alternate links
        window.location.reload();
      }
    },
  },
});
